import CreateConnectorDialog from "./CreateConnectorDialog";
import React, { useEffect, useState } from "react";
import {
    Box, Typography, Grid, Card, CardContent,
    Avatar, Button, CircularProgress, Tooltip
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ActiveBrokers = ({ onConnectorAdded }) => {
    const [brokers, setBrokers] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedBrokerId, setSelectedBrokerId] = useState(null);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


    useEffect(() => {
        const fetchActiveBrokers = async () => {
            try {
                const token = localStorage.getItem("token");
                const res = await axios.get(`${API_BASE_URL}/brokers/list/active`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const active = res.data.filter((b) => b.is_active === true);
                setBrokers(active);
            } catch (error) {
                console.error("Failed to fetch active brokers", error);
            } finally {
                setLoading(false);
            }
        };
        fetchActiveBrokers();
    }, []);

    if (loading) return <CircularProgress />;

    return (
        <Box mt={4}>
            <Typography variant="h6" gutterBottom>
                Active Broker
            </Typography>

            {brokers.length === 0 ? (
                <Typography color="text.secondary">No broker APIs configured yet.</Typography>
            ) : (
                <Grid container spacing={2} mt={1}>
                    {brokers.map((broker) => (
                        <Grid item xs={12} sm={6} md={4} key={broker._id}>
                            <Card variant="outlined" sx={{
                                textAlign: "center",
                                px: 1.5,
                                py: 1,
                                height: 160,           // 🔹 Optional: fixes max height
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                            }}>
                                <CardContent>
                                    <Avatar
                                        src={broker.iconUrl}
                                        alt={broker.brokerName}
                                        sx={{ width: 64, height: 64, mx: "auto", mb: 1 }}
                                        variant="square"
                                    />
                                    <Typography variant="subtitle1" fontWeight="bold">
                                        {broker.brokerName}
                                    </Typography>
                                    <Tooltip title="Create API Configuration">
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            sx={{ mt: 1 }}
                                            onClick={() => {
                                                setSelectedBrokerId(broker._id);
                                                setDialogOpen(true);
                                            }}
                                        >
                                            Create
                                        </Button>
                                        {dialogOpen && selectedBrokerId && (
                                            <CreateConnectorDialog
                                                brokerId={selectedBrokerId}
                                                open={dialogOpen}
                                                onClose={(success) => {
                                                    setDialogOpen(false);
                                                    setSelectedBrokerId(null);

                                                    if (success) {
                                                        onConnectorAdded();  // ✅ Trigger refresh if creation was successful
                                                    }
                                                }}
                                            />
                                        )}
                                    </Tooltip>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            )}
        </Box>
    );
};

export default ActiveBrokers;
